import {
  HTTP_INTERCEPTORS,
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideAngularSvgIcon } from 'angular-svg-icon';
import { provideToastr, ToastrModule } from 'ngx-toastr';
import {
  NgxUiLoaderConfig,
  NgxUiLoaderHttpModule,
  NgxUiLoaderModule,
  POSITION,
  SPINNER,
} from 'ngx-ui-loader';

import { API_BASE_URL } from './api/api-reference';
import { routes } from './app.routes';
import { AppConfig } from './config/config';
import { environment } from './environments/environment';
import { AuthInterceptor } from './interceptors/auth-interceptor';
import { StandardErrorInterceptor } from './interceptors/standard-error-interceptor';
import { RedirectInterceptor } from './interceptors/redirect-interceptor';
import { DATE_PIPE_DEFAULT_OPTIONS, DatePipe } from '@angular/common';
import { TimeZoneService } from './services/timezone.service';
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  bgsColor: '#198D52',
  fgsColor: '#198D52',
  bgsPosition: POSITION.centerCenter,
  overlayColor: 'var(--background-color-overlay)',
  bgsOpacity: 0.85,
  bgsSize: 70,
  fgsSize: 70,
  fgsType: SPINNER.rectangleBounce,
  bgsType: SPINNER.rectangleBounce,
};

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: DATE_PIPE_DEFAULT_OPTIONS,
      useFactory: (tzService: TimeZoneService) => ({
        timezone: tzService.timeZone
      }),
      deps: [TimeZoneService]
    },
    provideRouter(routes),
    { provide: API_BASE_URL, useValue: environment.pathApi },
    provideToastr(),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: StandardErrorInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RedirectInterceptor,
      multi: true,
    },
    AppConfig,
    provideAngularSvgIcon(),
    importProvidersFrom(
      NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
      NgxUiLoaderHttpModule.forRoot({
        showForeground: true,
        exclude: ['/assets', 'assets'],
      }),
      BrowserAnimationsModule,
      ToastrModule.forRoot({
        positionClass: 'toast-fixed',
        timeOut: 3000,
        closeButton: true,
        tapToDismiss: true,
      }),
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      }),
    ),
  ],
};
